import {
  DSCardWrapper,
  DSCircularButton,
} from "@components/design-system/molecules";
import {
  faEnvelopeOpen,
  faTrash,
} from "@fortawesome/pro-solid-svg-icons";

function formatDate(iso) {
  const d = new Date(iso);
  return d.toLocaleString();
}

export default function NotificationCard({
  notification,
  onClick,
  onMarkRead,
  onDismiss,
}) {
  const n = notification;
  const isUnread = !n.readAt;
  const isClickable = Boolean(n.actionUrl || n.noteUuid);

  return (
    <DSCardWrapper
      interactive={isClickable}
      onClick={isClickable ? () => onClick(n) : undefined}
      aria-label={n.title || "Notification"}
      dataTestId="notification-row"
    >
      <div className="flex items-start gap-3">
        {isUnread && (
          <span className="mt-1.5 h-2 w-2 rounded-full bg-red-500 shrink-0" />
        )}
        <div className="flex-1 min-w-0">
          {n.title && (
            <div className="text-sm font-medium text-primary">
              {n.title}
            </div>
          )}
          {n.message && (
            <div className="text-sm text-secondary mt-0.5">
              {n.message}
            </div>
          )}
          <div className="text-xs text-secondary mt-1">
            {formatDate(n.activeAt ?? n.createdAt)}
          </div>
        </div>
        <div className="flex flex-col items-center gap-2 shrink-0 self-center">
          {isUnread && (
            <DSCircularButton
              size="sm"
              variant="primary"
              icon={faEnvelopeOpen}
              onClick={(e) => {
                e.stopPropagation();
                onMarkRead(n);
              }}
              aria-label="Mark as read"
              title="Mark as read"
              dataTestId="notification-mark-read"
            />
          )}
          <DSCircularButton
            size="sm"
            variant="danger"
            icon={faTrash}
            onClick={(e) => {
              e.stopPropagation();
              onDismiss(n);
            }}
            aria-label="Dismiss"
            title="Dismiss"
            dataTestId="notification-dismiss"
          />
        </div>
      </div>
    </DSCardWrapper>
  );
}
